import axios from "axios";

export default class ImageUtility {
    public static async getBase64DataUrl(file:string):Promise<any> {

            const res = await fetch(file);
            const blob = await res.blob();

            return new Promise((resolve, reject) => {
                const reader  = new FileReader();
                reader.addEventListener("load", function () {
                    resolve(reader.result);
                }, false);

                reader.onerror = () => {
                    return reject(this);
                };
                reader.readAsDataURL(blob);
            })

    }
    public static async getBufferdUrl(file: string): Promise<string> {
        const fileType = file.substring(file.lastIndexOf('.') + 1);
        const mimeType = this.getMimeTypeForAttachment(fileType);
        // The downloadable file is only temporary and will be deleted after some time. The created file has to be
        // downloaded as blob and then be made savable with a Object URL
        const attachment = await axios.get(file, {responseType: 'blob'});
        const blob = new Blob([attachment.data], {type: mimeType, endings: 'native'});
        return window.URL.createObjectURL(blob);
    }

    private static getMimeTypeForAttachment(fileType: string): string {
        switch (fileType) {
            case 'pdf':
                return 'application/pdf';
            case 'png':
                return 'image/png';
            case 'jpg':
                return 'image/jpeg';
            case 'jpeg':
                return 'image/jpeg';
            // case '.csv': return 'text/csv';
            // add more mime types if needed
            default:
                throw new Error(`Filetype .${fileType} not supported!`);
        }
    }
}
